export default "__VITE_ASSET__PxUJvPXR__"